/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faPlus} from '@fortawesome/pro-solid-svg-icons';
import {faEnvelopeOpen} from '@fortawesome/pro-duotone-svg-icons';

const InviteIcon = ({icon, ...props}) => (
  <span className="fa-layers fa-fw">
    <FontAwesomeIcon icon={faEnvelopeOpen} {...props} />
    <FontAwesomeIcon
      icon={faPlus}
      style={{top: '-3px'}}
      transform="shrink-9"
      {...props}
    />
  </span>
);

export default InviteIcon;
